/**
 * Internal dependencies
 */
import './common'
import Block from './block'
import renderFrontend from '../../util/render-frontend.js'

const getProps = el => ( {
	attributes: JSON.parse( el.dataset.attributes ),
	hasVisibilitySensor: true,
} )

renderFrontend(
	'.wp-block-bwgb-products-deals-carousel__content',
	Block,
	getProps
)
